<div class="category-grid-section">
  <h2 class="section-title">{{ 'menu.categories' | translate }}</h2>

  <div class="category-list" *ngIf="categories.length > 0">
    <div
      *ngFor="let category of categories"
      class="category-card"
      (click)="onCategoryClick(category)">
      <div class="card-content">
        <div class="card-info">
          <h3 class="card-name">{{ getCategoryName(category) }}</h3>
          <span class="card-count">{{ getProductCount(category) }} {{ 'menu.items' | translate }}</span>
        </div>
        <!-- Categories without an image render text-only (no broken-image placeholder). -->
        <div class="card-image" *ngIf="getCategoryImage(category)" [class.loading]="!isImageLoaded(category.id)">
          <img [src]="getCategoryImage(category)" [alt]="getCategoryName(category)"
               (load)="onImageLoad(category.id)" (error)="onImageError(category.id)"
               [style.opacity]="isImageLoaded(category.id) ? 1 : 0" />
        </div>
      </div>
      <div class="card-border"></div>
    </div>
  </div>

  <div class="empty-state" *ngIf="categories.length === 0">
    <p>{{ 'menu.noCategories' | translate }}</p>
  </div>
</div>
